var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSenha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "senha",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.407,
    height: 13.513,
    viewBox: "0 0 10.407 13.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M58.592,13.513h6.555a1.906,1.906,0,0,0,1.926-1.9V7.355a1.884,1.884,0,0,0-1.4-1.841V3.472A3.444,3.444,0,0,0,62.258,0h-.777a3.47,3.47,0,0,0-3.456,3.464.467.467,0,0,0,.466.466.474.474,0,0,0,.466-.474A2.529,2.529,0,0,1,61.481.932h.777a2.509,2.509,0,0,1,2.485,2.54V5.436H58.592a1.926,1.926,0,0,0-1.926,1.926v4.256A1.9,1.9,0,0,0,58.592,13.513Zm7.549-1.926a.991.991,0,0,1-.994.994H58.592a.991.991,0,0,1-.994-.994V7.363a.991.991,0,0,1,.994-.994h6.555a.991.991,0,0,1,.994.994v4.225Z",
    transform: "translate(-56.666)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M224.189,330.506a.357.357,0,0,0,.356-.356v-1.127a.356.356,0,1,0-.712,0v1.127A.357.357,0,0,0,224.189,330.506Z",
    transform: "translate(-219.144 -319.197)",
    fill: "#ffbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenha);
export default __webpack_public_path__ + "static/media/senha.1fc607b0804f00d88b38bce335117b06.svg";
export { ForwardRef as ReactComponent };